import type { Event } from '@patsnap/tahiti-core/common/event';
import type { CustomHighlight } from '../types';

export const CustomHighlightService = Symbol.for('CustomHighlightService');

export interface CustomHighlightService {
    readonly onStatesChange: Event<CustomHighlight>;

    getModelData(): CustomHighlight;
    updateEnable(isEnable: boolean): void;
}
